/* Ensure an edited quantity list is saved before submitting its quote snapshot. */
(() => {
  const form = document.querySelector('[data-request-items]');
  if (!form) return;
  const fields = [...form.querySelectorAll('input[name="updates[]"]')];
  const values = fields.map(field => field.value);
  const button = document.querySelector('[data-request-send]');
  const notice = document.querySelector('[data-request-dirty]');
  function update() {
    const dirty = fields.some((field, index) => field.value !== values[index]);
    if (button) button.disabled = dirty;
    if (notice) notice.hidden = !dirty;
    return dirty;
  }
  form.addEventListener('input', update);
  document.getElementById('SunnyQuoteForm')?.addEventListener('submit', event => {
    if (update()) {
      event.preventDefault();
      form.querySelector('[name="update"]')?.focus();
    }
  });
})();
